import { useContext } from 'react'
import { context } from './context'
import { AppContext } from './Provider'

export default () => {
  const {
    wipes: { wipes, setWipes },
  } = useContext<AppContext>(context)

  return {
    wipes,
    setWipes,
    getLatestWipe: (): string => {
      if (!wipes?.length) {
        return ''
      }

      return wipes[0]
    },
  }
}
